
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.589 11.707a.696.696 0 00.696.696h9.423a.696.696 0 00.696-.696V9.015a.65.65 0 111.3 0v2.692a1.996 1.996 0 01-1.996 1.996H2.285a1.996 1.996 0 01-1.996-1.996V9.015a.65.65 0 111.3 0v2.692z","fill":"#58697D"}}),_c('path',{attrs:{"d":"M10.821 5.198a.65.65 0 010 .92L7.46 9.48a.655.655 0 01-.499.192.647.647 0 01-.423-.19L3.17 6.117a.65.65 0 01.92-.92l2.255 2.257V.946a.65.65 0 011.3 0v6.508l2.256-2.256a.65.65 0 01.92 0z","fill":"#58697D"}})])
          )
        }
      }
    